import * as $swal from "sweetalert2";
import Vue from "vue";

const base_url = 'https://api.cluna.app/'

const cookie_setting = "stg-sven-tdh";
const storage_path = "qti-innerStore-tdh";

const moment = require('moment-jalaali')
const axios = require('axios');
const bus = new Vue()

let oracle = {
    getBasket() {
        let data = localStorage.getItem("basket-cluna");
        if (data == null || data.trim().length == 0) {
            return [];
        }
        let array = data.split(",");
        if (array == null) {
            array = [];
        }
        return array;
    },
    setShop(request) {
        this.setData('shop-selected', request);
    },
    getShop() {
        return this.getData('shop-selected');
    }, openLink(URL) {
        window.open(URL, '_blank');
    },
    getCount(id, shopId) {
        if (shopId != null && this.getShop() != null) {
            if (this.getShop() != shopId) {
                return 0
            }
        }
        if (id != null) {
            let sum = 0
            let array = this.getBasket();
            for (let i = 0; i < array.length; i++) {
                if (array[i] == id) {
                    sum++
                }
            }
            return sum
        }
        let array = this.getBasket()
        if (array == null || array.length == 0) return 0
        let unique = []
        for (let i = 0; i < array.length; i++) {
            let exist = false
            let pr = array[i]
            for (let j = 0; j < unique.length; j++) {
                if (pr == unique[j]) {
                    exist = true
                    break
                }
            }
            if (!exist) {
                unique.push(pr)
            }
        }
        return unique.length
    },
    addToBasket(id) {
        let array = this.getBasket();
        array.push(id);
        localStorage.setItem("basket-cluna", array.join(","));
    },
    removeAllFromBasket(id) {
        let array = this.getBasket();
        array = array.filter(function (item) {
            return item !== id;
        });
        localStorage.setItem("basket-cluna", array.join(","));
    },
    removeFromBasket(id) {
        let array = this.getBasket();
        for (let i = 0; i < array.length; i++) {
            if (array[i] == id) {
                array.splice(i, 1);
                localStorage.setItem("basket-cluna", array.join(","));
                return;
            }
        }
    },
    clearBasket() {
        localStorage.setItem("basket-cluna", "");
    }, format(number) {
        if (number == 0) {
            return 0;
        } else if (number == null) {
            return "";
        }
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatDate(date, withHours = true) {
        let p = new Intl.DateTimeFormat('fa-IR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).formatToParts(new Date(date)).reduce((acc, part) => {
            acc[part.type] = part.value;
            return acc;
        }, {});
        if (withHours) {
            return `${p.year}/${p.month}/${p.day} ${p.hour}:${p.minute}`;
        } else {
            return `${p.year}/${p.month}/${p.day}`;
        }
    },
    encode(object) {
        if (object == null) {
            return null;
        }
        return encodeURIComponent(JSON.stringify(object));
    },
    decode(object) {
        if (object == null) {
            return null;
        }
        return this.nullify(JSON.parse(decodeURIComponent(object)));
    },
    setToken(request) {
        this.setData(storage_path, request, true);
    },
    getToken() {
        return this.getData(storage_path, true);
    },
    getData(key, secure) {
        let token = localStorage.getItem(key);
        if (token != null && token.length > 0) {
            if (!secure) {
                return JSON.parse(decodeURIComponent(token));
            } else {
                return atob(token);
            }
        }
        let name = key + "=";
        let data = document.cookie.split(";");
        for (let i = 0; i < data.length; i++) {
            let c = data[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                if (!secure) {
                    return JSON.parse(decodeURIComponent(c.substring(name.length, c.length)));
                } else {
                    return atob(c.substring(name.length, c.length));
                }
            }
        }
        return null;
    },
    setData(key, value, secure) {
        let data = "";
        if (value != null) {
            if (secure != null && secure) {
                data = btoa(value)
            } else {
                data = encodeURIComponent(JSON.stringify(value))
            }
        }
        localStorage.setItem(key, data);
        if (!secure) {
            return;
        }
        let date = new Date();
        date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
        let expires = "expires=" + date.toUTCString();
        document.cookie = key + "=" + data + ";" + expires + ";path=/";
    }, isMobile() {
        return window.screen.width < 700;
    },
    logOut() {
        let date = new Date();
        date.setTime(date.getTime() - 100 * 24 * 60 * 60 * 1000);
        let expires = "expires=" + date.toUTCString();
        document.cookie = storage_path + "=;" + expires + ";path=/";
        localStorage.removeItem(cookie_setting);
        localStorage.removeItem(storage_path);
    }, nullify(data) {
        let newData = {}
        for (let key in data) {
            let value = data[key];
            if (!this.isEmpty(value)) {
                newData[key] = value;
            }
        }
        return newData;
    },
    isEmpty(data) {
        if (data == null || (data == '' && data != 0)) {
            return true;
        }
        return false
    },
    isString(variable) {
        return (typeof variable === 'string' || variable instanceof String)
    }, showMessage(message, action, lambda, isSuccess) {
        let image
        if (isSuccess) {
            image = require("@/assets/image/checked.png")
        } else {
            image = (lambda == null ? require("@/assets/image/error.png") : require("@/assets/image/warning.png"))
        }
        $swal.fire({
            html: '<p>' + message + '</p>',
            showCloseButton: true,
            showConfirmButton: action != null,
            confirmButtonText: action,
            imageUrl: image,
            imageSize: '180x180',
            imageWidth: 70,
            imageHeight: 70,
            customClass: {
                popup: 'format'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                if (lambda != null) {
                    lambda()
                }
            }
        })
    },
    axios(url, data, onSuccess, onError, onProgress, extra) {
        axios({
            method: 'post',
            url: base_url + url,
            headers: {
                'Authorization': this.getToken(),
                'Content-Type': 'application/json;charset=UTF-8'
            },
            data: this.nullify(data),
            timeout: 30000,
            onDownloadProgress: function (progressEvent) {
                if (onProgress != null) {
                    onProgress(progressEvent)
                }
            },
        }).then(function (response) {
            if (response != null && response.data != null && response.data.success != null && response.data.success == true) {
                if (response.headers != null && response.headers['authorization'] != null) {
                    oracle.setToken(response.headers['authorization'])
                } else if (response.headers != null && response.headers['Authorization'] != null) {
                    oracle.setToken(response.headers['Authorization'])
                }
                if (onSuccess != null) {
                    if (extra != null) {
                        onSuccess(response.data, extra);
                    } else {
                        onSuccess(response.data);
                    }
                }
            } else {
                handleError(response != null ? response : null, onError)
            }
        }).catch(function (error) {
            handleError(error != null && error.response != null ? error.response : null, onError)
        });
    },
    axiosUpload(data, onSuccess, onError, onProgress, customName) {
        let formData = new FormData()
        if (customName != null) {
            formData.append("file", data, customName)
        } else {
            formData.append("file", data)
        }
        axios({
            method: 'post',
            url: base_url + "file/upload",
            data: formData,
            headers: {
                'Authorization': this.getToken(),
                'Content-Type': 'multipart/form-data'
            },
            timeout: 120000,
            onDownloadProgress: function (progressEvent) {
                if (onProgress != null) {
                    onProgress(progressEvent)
                }
            },
            onUploadProgress: function (progressEvent) {
                if (onProgress != null) {
                    onProgress(progressEvent);
                }
            }
        }).then(function (response) {
            if (response != null && response.data != null && response.data.success != null && response.data.success == true) {
                if (onSuccess != null) {
                    onSuccess(response.data)
                }
            } else {
                handleError(response != null ? response : null, onError)
            }
        }).catch(function (error) {
            handleError(error != null && error.response != null ? error.response : null, onError)
        });
    }
}

function handleError(param, onError) {
    if (param != null && param.data != null) {
        param = param.data
    }
    if (onError != null) {
        onError(param)
    }
    if (param != null && param.status != null && param.status == 401) {
        oracle.logOut()
        return
    }
    if (param != null && param.message != null) {
        oracle.showMessage(param.message)
    }
}

function print(val) {
    if (dev_mode) {
        console.log(val)
    }
}

export default oracle
export const event = bus
export const dev_mode = true
export const globals = {}
